// 中文-香港
export const ChineseHK: any = {
  language_code: "zh-HK",
  get_btn: "立即領取",
  unregistered_tip: "未註冊的用戶將直接創建帳戶",
  phone_number: "手機號碼",
  ver_code: "驗證碼",
  get_ver_code: "取得驗證碼",
  retrieve_ver_code: "重新獲取 ({SECONDS})",
  age_tip: "我已成年並具備完全民事行為能力，同意",
  and: "和",
  PRIVICY_POLICY: "《隱私政策》",
  MEMBER_AGGREMENT: "《會員條款》",
  agree_push: "本人同意以登記手機號碼或電郵接收海底撈推送訊息",
  CN: "中國",
  US: "美國",
  CA: "加拿大",
  GB: "英國",
  MY: "馬來西亞",
  AU: "澳洲",
  ID: "印尼",
  SG: "新加坡",
  TH: "泰國",
  JP: "日本",
  KR: "韓國",
  VN: "越南",
  HK: "香港地區",
  MO: "澳門地區",
  HKM: "柬埔寨",
  TW: "台灣地區",
  PH: "菲律賓",
  UAE: "阿聯酋",
  suc_send: "發送成功",
  suc_get: "領取成功",
  fail_ver_code: "驗證碼錯誤",
  time_end: "活動已結束",
  not_get_repeat: "無法重複領取！",
  not_get_eligible: "無法領取，不符合活動條件",
  not_get_late: "慢了一步，活動已經結束了",
  get_coupon: "領取優惠券",
  phone_err: "手機號碼錯誤，請輸入正確的手機號碼",
  page_title: "領取海底撈專屬優惠券",
  send_code_error: "發送驗證碼錯誤",
  network_error: "您當前的網絡異常，請稍後再試",
  member_status_abnormal: "會員帳戶異常，無法領取",
  send_frequently: "驗證碼發送次數過多。請輸入最後收到的驗證碼，或稍後再試。",
  activity_boom: "領取人數過多，請稍候再試",
  email: "Email",
  email_error_tip: "電郵錯誤，請輸入正確的電郵",
  suc_get_dialog_text: "立即開啟海底撈會員 APP，查看已領取的優惠券！",
  btn_sure: "確定",
  btn_cancel: "取消",
  suc_dialog_text: "開啟海底撈 APP 或在 LINE 綁定會員，查看已領取的優惠券!",
  btn_return: "返回",
  btn_download: "下載",
};
